import _ from 'lodash';
import { fork, put, take, select, takeLatest } from 'redux-saga/effects';

import { isIntroducer as isIntroducerSelector } from '../../../lendingAPI/lendingAPISelector';
import * as ExitPollActions from '../ExitPoll/ExitPoll.actions';

export function* enableExitPollSubmission() {
    yield takeLatest(ExitPollActions.EXIT_POLL_ANSWER, function* () {
        yield put({
            type: ExitPollActions.EXIT_POLL_ANSWER_SAVE_SUCCEED
        });
    });
}

export function* isExitPollEnabled() {
    const hasAnsweredExitPollBefore = yield select((state) => {
        const people = state.fetched.application.payload.people;
        if (people) {
            const applicant = _.find(people, (person) => {
                return _.includes(person.roles, 'applicant');
            });

            const exitPoll = applicant.how_did_you_find_us;
            if (exitPoll && (exitPoll.answer || exitPoll.details)) {
                return true;
            }
        }

        return state.exitPoll.saved;
    });

    const { isIntroducer } = yield select((state) => ({
        isIntroducer: isIntroducerSelector(state)
    }));

    return !isIntroducer && !hasAnsweredExitPollBefore;
}

export function* hasExitPollBeenAnswered() {
    const exitPoll = yield select((state) => state.exitPoll);
    return !exitPoll.enabled || exitPoll.saved || exitPoll.loading;
}

export function* waitForLoadingExitPoll() {
    const exitPoll = yield select((state) => state.exitPoll);
    if (exitPoll.enabled && exitPoll.loading) {
        yield take(ExitPollActions.EXIT_POLL_ANSWER_SAVE_SUCCEED);
    }
}

export default [fork(enableExitPollSubmission)];
